import React from 'react'
import { useNotify } from 'react-admin';
import DeleteFileConfirmBtn from './DeleteFileConfirmBtn';
import { notifyPopupBlocked, openWithPopupCheck } from '../../utils/popupWindow';


export default function FilePreviewThumnail({ img, alt = '', doc_id, file_name = '', isId = false,
  tag,
  invalidateQueries, file = img
}) {
  const notify = useNotify();

  return (
    <>
      {img &&
        <div className="d-inline-flex flex-column flex-wrap">
          <img
            src={img}
            style={{ maxWidth: '80px' }}
            className={'img-thumbnail ratio ratio-1x1'}
            alt=""
            onClick={() =>
              openWithPopupCheck(file, '_blank', undefined, {
                onBlocked: notifyPopupBlocked(notify),
              })
            }
            loading="eager"
          />
          <div className='' style={{ textAlign: 'center' }}>
            <p className='small pt-1' title={file_name} style={{ textAlign: 'center', fontSize: 10 }}>{file_name ? `${file_name.substring(0, 9)}...` : img && img.split('/').pop().split('_').pop().substring(0, 15)+'...'}</p>
           <DeleteFileConfirmBtn doc_id={doc_id}  invalidateQueries={invalidateQueries} tag={tag}  />
          </div>

        </div>}
    </>
  )
}


